import { Hidden } from '@mui/material'
import cn from 'classnames'
import Image from 'next/image'
import Link from 'next/link'
import React, { memo } from 'react'
import SearchJob from 'src/assets/job-illustration.png'
import HomeBuyVendorBadge from 'src/components/global/HomeBuyVendorBadge/HomeBuyVendorBadge'
import { JOB_URL } from 'src/config/config'

export const LegaltechJobsPanel: React.FC<{ className?: string }> = memo(({ className }) => {
  return (
    <div className={cn(className, 'flex flex-col md:flex-row md:items-start items-center mx-auto')}>
      <Hidden mdDown>
        <div className="flex w-1/2">
          <Image src={SearchJob} className="w-[239.8px] h-[192px]" width={239.8} height={192} alt="" />
        </div>
      </Hidden>
      <div className="flex md:w-1/2 flex-col px-5 md:px-0">
        <HomeBuyVendorBadge />
        <div className="text-[1.6rem] font-bold mt-2">Search Legaltech Jobs</div>
        <div className="flex flex-col mt-[.4rem] font-primary text-[18px] mb-6 leading-6">
          Legaltech Jobs provides targeted job listings for alternative careers in law, including roles in legal
          technology, legal data, legal operations, legal design, and legal innovation. Click and browse to find your
          next opportunity!
        </div>
        <Link
          href={JOB_URL}
          target="_blank"
          style={{ fontSize: '14px', lineHeight: '50px', borderRadius: '25px' }}
          className="text-white font-secondary text-[14px] font-bold text-center rounded-[22.5px] px-[25px] bg-navy mt-[.6125rem] w-[9rem] mr-auto"
        >
          Search Now
        </Link>
      </div>
    </div>
  )
})
